import { Linkedin, Instagram } from "lucide-react";
import { Reveal, SectionTitle } from "@/components/ui-bits";

const team = [
  {
    name: "Belinda Palacios",
    role: "Autora, Productora Ejecutiva y Coguionista",
    img: "/team-belinda.jpg",
    imgClass: "object-[center_18%] scale-[1.08]",
    bio: "Doctora en literatura con más de 20 trabajos académicos publicados, hoy canaliza su experiencia creando historias que emocionan y conectan. Su segunda novela, Esporas, se encuentra hoy en proceso de edición. Es también la creadora de la saga juvenil Myra O'Connor, cuyo primer tomo, Myra O'Connor y el inicio de Halloween, acaba de ser publicado bajo el sello de Penguin Kids. Actualmente lidera el Proyecto Niñagordita.",
    icon: Linkedin,
    url: "https://www.linkedin.com/in/belinda-palacios-patow-23b026105/",
    network: "LinkedIn",
    testid: "team-belinda",
  },
  {
    name: "Silvana Cañote",
    role: "Productora Ejecutiva y Protagonista",
    img: "/team-silvana.jpg",
    imgClass: "object-[center_12%]",
    bio: "A los 13 años debutó en cine y protagonizó una serie juvenil en televisión abierta que duró seis temporadas. Desde entonces ha construido una carrera que se consolida con su papel en Sube a mi Nube (2024). Actriz y socióloga de formación, con Niñagordita incursiona como productora ejecutiva, llevando a la pantalla historias femeninas reales.",
    icon: Instagram,
    url: "https://www.instagram.com/silvana.canote/?hl=es",
    network: "Instagram",
    testid: "team-silvana",
  },
  {
    name: "Camila Vidal",
    role: "Directora y Coguionista",
    img: "/team-camila.png",
    imgClass: "object-[center_20%]",
    bio: "Guionista y directora de cine peruana radicada en Los Ángeles, con un Máster en Dirección Cinematográfica (MFA) por CalArts. Su cortometraje «THEN, MOTHER» fue selección oficial del Festival de Cine de Lima 2022. Su más reciente cortometraje, «PEÑASCAL», se estrenó en el Disney Hall Center y fue seleccionado por el jurado del CalArts Showcase 2024 en la categoría de Mejores Directoras. Ha sido reconocida como una de las mejores directoras mujeres por Free The Work y recibió la beca de la Asociación de la Prensa Extranjera de Hollywood.",
    icon: Instagram,
    url: "https://www.instagram.com/camilavidaland/?hl=es",
    network: "Instagram",
    testid: "team-camila",
  },
  {
    name: "Cristina Puma",
    role: "Empresaria y Estratega de Innovación",
    img: "/team-cristina.png",
    imgClass: "object-[center_20%]",
    bio: "Cristina Puma es empresaria y estratega de innovación. Como fundadora de Making Connexion y Content Media, ha desarrollado metodologías, estrategias y productos tecnológicos que ayudan a organizaciones a convertir ideas en proyectos con impacto público. Su experiencia integra negocios, comunicación e innovación para construir alianzas, movilizar audiencias y generar cambios culturales. Es licenciada en Gestión Empresarial por la Pontificia Universidad Católica del Perú (PUCP).",
    icon: Linkedin,
    url: "https://www.linkedin.com/in/cristinapuma/",
    network: "LinkedIn",
    testid: "team-cristina",
  },
];

export default function Nosotras() {
  return (
    <section id="nosotras" data-testid="section-nosotras" className="py-24 sm:py-32 bg-white border-t border-[#e2dccd]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTitle tone="gray">Nosotras</SectionTitle>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((m, idx) => {
            const Icon = m.icon;
            return (
              <Reveal key={m.name} delay={idx * 0.1}>
                <article data-testid={m.testid} className="h-full bg-[#F2EDE3] rounded-3xl p-6 border border-[#ece5d6] flex flex-col">
                  <div className="relative w-full max-w-[240px] mx-auto aspect-square overflow-hidden rounded-2xl bg-[#e6e0d4]">
                    {m.img ? (
                      <img
                        src={m.img}
                        alt={m.name}
                        className={`absolute inset-0 w-full h-full object-cover ${m.imgClass || ""}`}
                        draggable={false}
                      />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center font-display text-lg uppercase tracking-wide text-[#8a8270]">
                        Foto
                      </div>
                    )}
                  </div>
                  <h3 className="mt-6 font-display text-3xl text-[#C20A78] uppercase leading-none">{m.name}</h3>
                  <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-[#6E6A66]">{m.role}</p>
                  <p className="mt-4 text-sm leading-relaxed text-[#141414]/80 flex-grow">{m.bio}</p>
                  {m.url && (
                    <a
                      data-testid={`${m.testid}-social`}
                      href={m.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#C20A78] hover:text-[#8F0759] transition-colors"
                    >
                      <Icon size={18} /> {m.network}
                    </a>
                  )}
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
